import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "../about-upsc/about-upsc.module.css";


const About_Civil_Service = () => {

    const subject =[
        {cont:"Subjects",cont1:"Papers",cont2:"Marks"},
        {cont:"Indian Language",cont1:"Paper-A",cont2:"300",star:"*"},
        {cont:"English",cont1:"Paper-B",cont2:"300",star:"*"},
        {cont:"Essay",cont1:"Paper-I",cont2:"250"},
        {cont:"General Studies 1",cont1:"Paper-I",cont2:"250"},
        {cont:"General Studies 2",cont1:"Paper-II",cont2:"250"},
        {cont:"General Studies 3",cont1:"Paper-III",cont2:"250"},
        {cont:"General Studies 4",cont1:"Paper-IV",cont2:"250"},
        {cont:"Optional Subject",cont1:"Paper-VI",cont2:"250"},
        {cont:"Optional Subject",cont1:"Paper-VII",cont2:"250"}
      ]
        
  return (
    <>
                   <div className="container"> 
                        <div className="row">
                            <div className="col">
                                <h2 className={`${styles.sectiontitle} mb-0`}>Overview</h2>
                                <p className={`${styles.acheiverrank} pt-md-2`}>Civil Service Examination consists of 3 stages as mentioned below:</p>
                            </div>
                        </div>
                    </div>

                <div className="container"> 
                        <div className="row pt-3">
                                <ul className="mb-0" style={{listStyle:"none !important"}}>
                                    <li className={`${styles.tlitem}`}>
                                        <p className={`${styles.acheiverrank} mb-0`}>Stage 1</p>
                                        <p className={`${styles.acheivername}`}>Preliminary Exam (Objective Type)</p>
                                    </li>

                                    <li className={`${styles.tlitem1}`}>
                                        <p className={`${styles.acheiverrank} mb-0`}>Stage 2</p>
                                        <p className={`${styles.acheivername}`}>Mains Exam (Descriptive Type)</p>
                                    </li>

                                    <li className={`${styles.tlitem2}`}>
                                        <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                                        <p className={`${styles.acheivername}`}>Interview (Oral)</p>
                                    </li>

                                </ul>

                        </div>
                    </div>
                       
                    <div className="container">
                            <div className="row pt-2">
                                <div className="col">
                                    <h2 className={`${styles.sectiontitle} mb-0`}>Preliminary Exam (For Civil & Forest Service)</h2>
                                    <p className={`${styles.acheiverrank} pt-md-2`}>The Preliminary Examination which is common for both Civil services and 
                                    Forest service is conducted during May or June every year. It consists of two papers - one is held in the forenoon and 
                                    the other in the afternoon of the same day and both papers consist of a set of multiple choice questions. 
                                    The forenoon session is General Studies Paper–I where questions are based on general awareness and other 
                                    topics as mentioned in the syllabus. In afternoon session is CSAT – Paper II where questions based on Quantitative aptitude, 
                                    Reasoning and Verbal ability as mentioned in syllabus. Candidates should note that there will be a penalty (negative marking) for wrong answers</p>
                                    <p className={`${styles.acheiverrank} pt-2`}> Information given below are based on UPSC Civil Services Examinations 2018.</p>
                                </div>
                            </div>
                        </div>


                    <div className="container">

                         {/*General Stidies Section*/}
                            <div className="row">
                                <div className="col-xl-4 col-lg-5 col-md-6 col-12 mb-3">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2}`}>General Studies Paper–I</p>

                                            <div className="row">
                                                <div className="col-8">
                                                  <p className={`${styles.acheiverrank}`}>No. of Questions</p>
                                                </div>
                                                <div className="col-4">
                                                  <p className={`${styles.aboutnumber}`}>100</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-8">
                                                  <p className={`${styles.acheiverrank}`}>Total Marks</p>
                                                </div>
                                                <div className="col-4">
                                                  <p className={`${styles.aboutnumber}`}>200</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-8">
                                                  <p className={`${styles.acheiverrank}`}>Marks for Correct Answer</p>
                                                </div>
                                                <div className="col-4">
                                                  <p className={`${styles.aboutnumber}`}>2</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-8">
                                                  <p className={`${styles.acheiverrank}`}>Marks for Incorrect Answer</p>
                                                </div>
                                                <div className="col-4">
                                                  <p className={`${styles.aboutnumber}`}>-0.66</p>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                    
                        



                             <div className="col-xl-4 col-lg-5 col-md-6 col-12 mb-3">
                                  <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                     <p className={`${styles.aboutheading2}`}>CSAT – Paper II</p>
                                        <div className="row">
                                                <div className="col-8">
                                                <p className={`${styles.acheiverrank}`}>No. of Questions</p>
                                                </div>
                                                <div className="col-4">
                                                <p className={`${styles.aboutnumber}`}>80</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col-8">
                                                <p className={`${styles.acheiverrank}`}>Total Marks</p>
                                                </div>
                                                <div className="col-4">
                                                <p className={`${styles.aboutnumber}`}>200</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col-8">
                                                <p className={`${styles.acheiverrank}`}>Marks for Correct Answer</p>
                                                </div>
                                                <div className="col-4">
                                                <p className={`${styles.aboutnumber}`}>2.5</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col-8">
                                                <p className={`${styles.acheiverrank}`}>Marks for Incorrect Answer</p>
                                                </div>
                                                <div className="col-4">
                                                <p className={`${styles.aboutnumber}`}>-0.83</p>
                                                </div>
                                        </div>
                                 </div>
                             </div>

                         </div>
                      </div>
                     
                 
          
                        <div className="container">
                            <div className="row pt-3">
                                <div className="col">
                                    <p className={`${styles.aboutparagraph1} p-2`} id={styles.widthmax}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; For Wrong answers one - third of the marks assigned to that question will be deducted as penalty.</p>
                                </div>
                            </div>
                       </div>
                   
                

                        <div className="container">
                            <div className="row">
                                <div className="col">
                                    <p className={`${styles.aboutheading1} mb-0`}>Result</p>
                                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                                <div className="d-inline">
                                                    <p className={`${styles.ullispan} d-inline`}>
                                                    Paper I marks is used for the selection of candidates to the mains examination.
                                                    </p>
                                                </div>
                                            </li>

                                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                                <div className="d-inline">
                                                    <p className={`${styles.ullispan} d-inline`}>
                                                    Paper II marks is qualifying paper with a minimum qualifying marks fixed at 33% (i.e 66 marks).
                                                    </p>
                                                </div>
                                            </li>

                                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                                <div className="d-inline">
                                                    <p className={`${styles.ullispan} d-inline`}>
                                                    Two set of results are published - one list is for those who qualified for Civil Service Mains 
                                                     Examinations and other list is for those who qualified for Forest Service &nbsp; Mains Examination.
                                                    </p>
                                                </div>
                                            </li>

                                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                                <div className="d-inline">
                                                    <p className={`${styles.ullispan} d-inline`}>
                                                    This is only a screening test, marks will not be added in calculating final results.
                                                    </p>
                                                </div>
                                            </li>

                                            
                                    </ul>
                                    
                                </div>
                            </div>
                        </div>

                        <div className="container">
                        <div className="row pt-3">
                            <div className="col">
                                <h2 className={`${styles.sectiontitle} mb-0`}>Mains Examination</h2>
                                <p className={`${styles.acheiverrank} pt-md-2`}>Mains Examination syllabus, pattern and schedule is different for Civil Service and Forest Service Examination.</p>
                            </div>
                        </div>
                    </div>


                    <div className="container">
                        <div className="row pt-3">
                            <div className="col">
                                <h2 className={`${styles.sectiontitle} mb-0`}>Civil Service Mains Examinations</h2>
                                <p className={`${styles.acheiverrank} pt-md-2`}>The candidates who qualify for Civil Service Mains Examination have to choose one optional subject which has two papers.</p>
                                <p className={`${styles.acheiverrank} pt-2`}>The mains examination is intended to assess the overall intellectual traits and depth of understanding of candidates rather
                                than merely the range of their information and memory. The nature and standard of questions in the General Studies papers (Paper II to Paper V)
                                will be such that a well-educated person will be able to answer them without any specialized study. The questions will be such as to test a candidate’s
                                general awareness of a variety of subjects, which will have relevance for a career in the Civil Services. The questions are likely to test the candidate’s 
                                basic understanding of all relevant issues, ability to analyze and take a view on conflicting socio-economic goals, objectives and demands. The candidates 
                                must give relevant, meaningful and succinct answers.</p>
                                <p className={`${styles.acheiverrank} pt-2`}>The scope of the syllabus for optional subject papers (Paper VI and Paper VII) for the examination is broadly of the honours degree 
                                level i.e. a level higher than the bachelors degree and lower than the masters degree. In the case of Engineering, Medical Science and Law, the level corresponds 
                                to the bachelors degree. </p>
                                <p className={`${styles.acheiverrank} pt-2`}>In all, the aspirants are to appear in nine papers, details of which are given below:</p>
                            </div>
                        </div>
                    </div>


                {/*Subject List Section */}

                <div className="container">

                    <div className="row  pt-2">
                      {subject.map((item,index)=>(
                        <div className="col-lg-7 col-md-9 col-12" key={index}>
                           <div className="row mx-auto">
                                <div className="col">
                                    <p className={`${styles.aboutheading2}`}>{item.cont}<span className={`${styles.star}`}>{item.star}</span></p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.aboutheading2}`}>{item.cont1}</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.aboutheading2}`}>{item.cont2}</p>
                                </div>
                                <hr></hr>
                           </div>
                          </div> 
                          ))}
                    </div>

                </div>
                    
              
                <div className="container">
                    <div className="row pt-2">
                        <div className="col">
                            <p className={`${styles.aboutparagraph1} p-2`} id={styles.widthmax}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; Qualifying Papers - For qualifying, candidates have to secure a minimum of 25% in these papers.</p>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row pt-2 pt-md-3">
                        <div className="col">
                            <h2 className={`${styles.sectiontitle} mb-0`}>Interview</h2>
                            <p className={`${styles.acheiverrank} pt-2`}>Interview for Personality test will be conducted in Delhi for candidates who clear the Mains examination. (Maximum mark : 275)</p>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row pt-2 pt-md-3">
                        <div className="col">
                            <h2 className={`${styles.sectiontitle} mb-0`}>Final Results</h2>
                            <p className={`${styles.acheiverrank} pt-2`}>Final Result of both Civil Services and Forest Service exam will be based on Mains examination and Interview marks.</p>
                        </div>
                    </div>
                </div>
</>
  )
}

export default About_Civil_Service;